module.exports = __webpack_public_path__ + "img/img-1.bb0f65d2.jpg";